/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var PlusSquareIcon16Light = forwardRef('PlusSquareIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 4.413a.5.5 0 1 0-1 0V7H4.413a.5.5 0 1 0 0 1H7v2.587a.5.5 0 0 0 1 0V8h2.587a.5.5 0 0 0 0-1H8V4.413Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 1a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H4ZM2 4a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Z" })));
});
